/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Too_Many_JobsInputs */

const en_company_jobs_too_many_jobs = /** @type {(inputs: Company_Jobs_Too_Many_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many job positions. Pagination is not available yet.`)
};

const de_company_jobs_too_many_jobs = /** @type {(inputs: Company_Jobs_Too_Many_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Stellenangebote. Die seitenweise Anzeige ist noch nicht verfügbar.`)
};

/**
* | output |
* | --- |
* | "Too many job positions. Pagination is not available yet." |
*
* @param {Company_Jobs_Too_Many_JobsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_too_many_jobs = /** @type {((inputs?: Company_Jobs_Too_Many_JobsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Too_Many_JobsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_too_many_jobs(inputs)
	return en_company_jobs_too_many_jobs(inputs)
});